import React from 'react';
import { FiDownload } from 'react-icons/fi';
import { Button } from 'react-bootstrap';
import { triggerFileDownload } from '../utilities/common';

const DownloadHelper = ({ getLinkObject, label = 'Download' }) => {
  const handleDownload = async() => {
    const result = await getLinkObject();
    triggerFileDownload(result.objectUrl, result.fileName);
  };
  return (
    <Button variant="link" onClick={handleDownload}>
      {label} <FiDownload className="ml-1" />
    </Button>
  );
};

export default DownloadHelper;
